
import { LazyLoadImage } from "react-lazy-load-image-component";
import { baseUrl, DOWNLOAD_FILE } from "../../../../../../shared/api/endpoints.js";

const Image = ({ className, id, size, width, height, defualtWidth ,alt}) => {
  return (
    <div className={className || ""}>
      {id ? (
        <LazyLoadImage
          src={`${baseUrl}/${DOWNLOAD_FILE}/` +  id   + `?size=${size ? size : "large"}`}
          width={width ? width : "auto"}
          height={height ? height : "auto"}
          effect="opacity"
          data-srcset={`
     ${baseUrl}/${DOWNLOAD_FILE}+ "?size=thumbnail"} 150w,
     ${baseUrl}/${DOWNLOAD_FILE}+ "?size=small"} 300w,
     ${baseUrl}/${DOWNLOAD_FILE}+ "?size=medium"} 768w,
     ${baseUrl}/${DOWNLOAD_FILE}+ "?size=large"} 1024w,
     ${baseUrl}/${DOWNLOAD_FILE}+ ""} 2000w,
      `}
          placeholderSrc={
            `${baseUrl}/${DOWNLOAD_FILE}` + { id } + "?size=favicon"
          }
          alt="Image Alt"
          delayTime={1}
          className={className || ""}
        />
      ) : (
        <img
          src="/images/icons/no-image.svg"
          alt=""
          width={defualtWidth ? defualtWidth : width ? width : "auto"}
          height={height ? height : "auto"}
          className={className || ""}
        />
      )}
    </div>
  );
};

export default Image;
